import { filter } from 'rxjs'

export const filterIsDefined = <T>() => filter((v: T | undefined): v is T => v !== undefined)
export const filterIsNotNull = <T>() => filter((v: T | null): v is T => v !== null)
export const filterIsValid = <T>() => filter((v: T | null | undefined): v is T => v !== null && v !== undefined)
